<template>
  <div class="hello">
    <User/>
    <div class="container box mainBox">
      <Charts/>
      <Ad1/>
    </div>
  </div>
</template>

<script>
import Charts from './Charts'
import Vote from './Vote'
import User from './User'
import Ad1 from './ad/Ad1'
import moment from 'moment-timezone'

moment.tz.setDefault('Asia/Tokyo')

export default {
  name: 'Main',
  components: {
    Charts,
    Vote,
    User,
    Ad1
  },
  data () {
    return {}
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mainBox{
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Main.vue